import { Pill } from '@warp-ds/react/components/pill';
import { connect } from 'react-redux';

import type { ApiQueryParams, PaleState } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { actions as filterActions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import {
    boundingBoxToFilterData,
    checkboxToFilterData,
    checkboxTreeToFilterData,
    type FilterData,
    numberRangeToFilterData,
    type ResetCurrentFilterPayload,
    stringToFilterData,
} from './filterToFilterData';

const originAirports: Record<string, string> = displayValues.originAirports;
const meals: Record<string, string> = displayValues.amenities.meals;
const facilities: Record<string, string> = displayValues.amenities.facilities;
const activities: Record<string, string> = displayValues.amenities.activities;

export interface CurrentFiltersProps {
    filterList: FilterData[];
    resetFilter: (payload: ResetCurrentFilterPayload) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
}

export const CurrentFilters = ({ filterList, resetFilter, triggerFetch }: CurrentFiltersProps) =>
    filterList.length ? (
        <div className="flex flex-wrap gap-8 py-16">
            {filterList.map((filter) => (
                <Pill
                    canClose
                    label={filter.displayName}
                    openSRLabel="Valgt filter:"
                    key={filter.id}
                    onClose={(): void => {
                        resetFilter({ location: filter.location, filterType: filter.filterType, value: filter.value });
                        triggerFetch();
                    }}
                />
            ))}
        </div>
    ) : null;

const mapStateToProps = ({ filters }: PaleState): { filterList: FilterData[] } => ({
    filterList: [
        ...stringToFilterData(filters.origin, (a) => `Avreise fra ${originAirports[a]}`, 'origin'),
        ...checkboxTreeToFilterData(filters.destinations.tree),
        ...boundingBoxToFilterData(filters.boundingBox, filters.destinationLabel),
        ...numberRangeToFilterData(filters.priceRange, 'Pris', 'kr', 'priceRange'),
        ...checkboxToFilterData(filters.rating, (a) => `${a} - stjerner`, 'rating'),
        ...numberRangeToFilterData(filters.distanceToBeach, 'Avstand strand', 'm', 'distanceToBeach'),
        ...numberRangeToFilterData(filters.distanceToCity, 'Avstand sentrum', 'm', 'distanceToCity'),
        ...checkboxToFilterData(filters.meals, (a) => meals[a], 'meals'),
        ...checkboxToFilterData(filters.facilities, (a) => facilities[a], 'facilities'),
        ...checkboxToFilterData(filters.activities, (a) => activities[a], 'activities'),
        ...stringToFilterData(filters.keywords, (a) => `Fritekst: ${a}`, 'keywords'),
        ...checkboxToFilterData(filters.suppliers, (a) => `Tilbyder: ${a}`, 'suppliers'),
    ],
});

const mapDispatchToProps = { resetFilter: filterActions.filterResetSpecific, triggerFetch: fetchResults };

export default connect(mapStateToProps, mapDispatchToProps)(CurrentFilters);
